import React from 'react'
import clsx from 'clsx'
import { ArrowDown2 } from 'iconsax-react'
import { useTheme } from '@mui/material'

import useStyles from './styles'

const Accordion = ({
  title,
  content,
  noContentPadding = false,
  rootClass = undefined,
  containerClass = undefined,
  containerTitleClass = undefined,
  defaultOpen = true
}) => {
  const theme = useTheme()

  const [isOpen, setIsOpen] = React.useState(defaultOpen)

  const handleToggleClick = React.useCallback(() => {
    setIsOpen(old => !old)
  }, [])

  const classes = useStyles({ expanded: isOpen })

  return (
    <div className={clsx(rootClass, classes.accordion)}>
      <div className={clsx(containerClass, classes.accordionContainer)}>
        <div
          className={clsx(containerTitleClass, classes.accordionTitle)}
          onClick={handleToggleClick}
        >
          <div className={classes.titleText}>{title}</div>
          <div className={classes.icon}>
            <ArrowDown2 size={theme.size.base} />
          </div>
        </div>
        <div className={classes.accordionContent} aria-expanded={!isOpen}>
          <div className={!noContentPadding && classes.accordionPadding}>
            {content}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Accordion
